export default { sha: 'd21f18ec8bc91162aa227ac2a8001c362cb9530a', buildNumber: 'undefined' }
